<template>
  <div>
    <div class="over-text text-medium my-5 text-center relative -top-5 leading-22" ref="textTips" v-if="enableDimensionScore">
      <div class="score">
        <p>
          本次评测总得分：<span>{{ answerDimensionScore.score }}</span> 分
        </p>
      </div>
      <div class="w-full mt-1">
        <el-button type="text" size="mini" @click="showReport" v-if="!reportVisibility">查看测评报告</el-button>
        <div v-else class="leading-18 font-medium text-theme-black-850">{{ survey.title }}</div>
      </div>
    </div>
    <div class="over-text text-medium my-5 text-center" ref="textTips" v-else-if="!isWait && !enableDimensionScore">
      <!-- 证书 -->
      <template v-if="enableCertificateScore && overData.answerCertificate && (isScoreSurvey || overData.answerCertificate.effType === 1)">
        <certificate-info :overData="overData" :survey="survey" />
      </template>
      <!-- 考试-显示得分 -->
      <template v-else-if="isScoreSurvey && enableScoreInfo && answerId">
        <score-info />
      </template>
      <!-- 考试-普通样式 -->
      <template v-else>
        <div v-for="(text, index) in answerTextTips" :key="index">
          <div v-html="text"></div>
        </div>
      </template>
    </div>
    <vote-answer />
    <AnswerAnalysis v-if="reportVisibility"></AnswerAnalysis>
  </div>
</template>

<script>
import { busGetters } from 'dygc'
import AnswerAnalysis from '@/components/end/AnswerAnalysis'
import ScoreInfo from '@/components/end/ScoreInfo'
import CertificateInfo from './CertificateInfo.vue'
import VoteAnswer from '@/components/end/VoteAnswer.vue'

export default {
  name: 'AnswerText',
  components: { VoteAnswer, ScoreInfo, AnswerAnalysis, CertificateInfo },
  data() {
    return {
      reportVisibility: false
    }
  },
  methods: {
    showReport() {
      this.reportVisibility = true
    }
  },
  computed: {
    isScoreSurvey() {
      return this.$bus.isScoreSurvey
    },
    enableScoreInfo() {
      const os = this.$bus.survey.otherSetting
      return os.enableScoreInfo
    },
    enableCertificateScore() {
      const os = this.$bus.survey.otherSetting
      return os.enableCertificateScore
    },
    surveyTitle() {
      return this.$bus.survey.title
    },
    ...busGetters(['answerTextTips', 'enableDimensionScore', 'score', 'isWait', 'survey', 'answerDimensionScore', 'overData','answerId'])
  },
}
</script>
<style lang="scss" scoped>
.score {
  p {
    @apply text-theme-black-650;
    span {
      @apply text-theme-black-850 font-bold;
    }
  }
}
</style>
